import type { ReactNode } from "react";

type CardProps = {
  id?: string;
  title?: string;
  eyebrow?: string;
  description?: string;
  children?: ReactNode;
  footer?: ReactNode;
  className?: string;
};

export function Card({
  id,
  title,
  eyebrow,
  description,
  children,
  footer,
  className = "",
}: CardProps) {
  return (
    <article id={id} className={`surface-card flex h-full flex-col p-6 md:p-7 ${className}`.trim()}>
      {eyebrow ? (
        <p className="text-sm font-bold uppercase tracking-wide text-mint-dark">{eyebrow}</p>
      ) : null}
      {title ? <h3 className="mt-3 text-xl font-bold">{title}</h3> : null}
      {description ? <p className="mt-3 text-ink-soft">{description}</p> : null}
      {children}
      {footer ? <div className="mt-auto pt-5">{footer}</div> : null}
    </article>
  );
}
